module.exports = __webpack_public_path__ + "img/CottageOutlined.64222a93.svg";